import {
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import { ChangeEvent, useCallback } from "react";
import { CouponDetails } from "src/api/types";
import { columns } from "../../utils/columns";
import { useUpdateCouponMutation } from "src/api/services/couponsApi";

interface Props {
  row: CouponDetails;
}

const CouponsTableRow = ({ row }: Props) => {
  const [updateCoupon] = useUpdateCouponMutation();

  const handleStatusUpdate = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;

      updateCoupon({
        id: row.id,
        is_active: Boolean(value),
      });
    },
    [row.id, updateCoupon]
  );

  return (
    <TableRow hover role="checkbox" aria-label="plan row" tabIndex={-1}>
      {columns.map((column, idx) => {
        const value = column.format(row);

        const isStyled = ["status"].includes(column.id);

        return (
          <TableCell key={idx} align={column.align} sx={{ padding: "8px" }}>
            {column.id === "active" ? (
              <TextField
                select
                value={Number(row.is_active)}
                size="small"
                onChange={handleStatusUpdate}
              >
                <MenuItem value={1}>{"Active"}</MenuItem>
                <MenuItem value={0}>{"Inactive"}</MenuItem>
              </TextField>
            ) : (
              <Typography
                sx={{
                  textDecoration: isStyled ? "underline" : "none",
                  cursor: isStyled ? "pointer" : "",
                }}
              >
                {value}
              </Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default CouponsTableRow;
